import { styled, Avatar, Box } from "@mui/material";

export const StyledListImage = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
  objectFit: "contain",
  cursor: "pointer",

  ".MuiAvatar-img": {
    height: "auto",
    borderRadius: 5,
  },
}));

export const EnlargedImage = styled("img")({
  objectFit: "contain",
  maxWidth: "100%",
  maxHeight: "100%",
  borderRadius: "5px",
});

export const EnlargedImageWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3),
  height: "340px",
}));

export const TitleText = styled("span")({
  whiteSpace: "nowrap",
});

export const TitleWrapper = styled(Box)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "min-content",
  maxWidth: "100%",
});
